import React, { useContext, useMemo, useState } from "react";
import AuthContext from "../Context/AuthContext";

export default function Header() {
  const { loggedIn, userData } = useContext(AuthContext);
  const user = userData?.user?.user;
  const name = user?.name || "";
  const initials = useMemo(
    () => (name?.trim()?.[0] ? name.trim()[0].toUpperCase() : "U"),
    [name]
  );

  const [open, setOpen] = useState(false);

  const logOut = () => {
    localStorage.setItem("auth-token", "");
    window.location.href = "/home"; // tam sayfa yönlendirme
  };

  const NavA = ({ href, children }) => (
    <a
      href={href}
      className="px-3 py-2 text-sm font-semibold text-slate-700 hover:text-slate-900"
      onClick={() => setOpen(false)}
    >
      {children}
    </a>
  );

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/50">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex h-16 items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="/um.png" alt="Logo" className="h-10 w-10 rounded-md object-contain" />
            <span className="sr-only">Home</span>
          </a>

          <nav className="hidden md:flex items-center gap-2">
            {loggedIn ? (
              <>
                <div className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1">
                  <div className="h-6 w-6 rounded-full bg-blue-100 text-blue-700 grid place-items-center text-xs font-bold">
                    {initials}
                  </div>
                  <span className="text-sm font-semibold text-slate-800 truncate max-w-[180px]">
                    {name}
                  </span>
                </div>
                <NavA href="/guidelines">PANEL</NavA>
                <button
                  onClick={logOut}
                  className="ml-1 inline-flex items-center rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700"
                >
                  LOG OUT
                </button>
              </>
            ) : (
              <>
                <NavA href="/">HOME</NavA>
                <NavA href="/about">ABOUT US</NavA>
                <NavA href="/contact">CONTACT US</NavA>
                <a
                  href="/login"
                  className="ml-1 inline-flex items-center rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700"
                >
                  LOGIN
                </a>
              </>
            )}
          </nav>

          <button
            className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-slate-600 hover:bg-slate-100"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" />
              )}
            </svg>
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
              {loggedIn ? (
                <>
                  <div className="mb-2 flex items-center gap-3 rounded-xl bg-blue-50 p-3">
                    <div className="h-8 w-8 rounded-full bg-blue-100 text-blue-700 grid place-items-center text-sm font-bold">
                      {initials}
                    </div>
                    <div className="min-w-0">
                      <div className="text-sm font-semibold text-slate-800 truncate">{name}</div>
                    </div>
                  </div>
                  <NavA href="/guidelines">PANEL</NavA>
                  <button
                    onClick={logOut}
                    className="mt-2 w-full rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700"
                  >
                    LOG OUT
                  </button>
                </>
              ) : (
                <>
                  <NavA href="/">HOME</NavA>
                  <NavA href="/about">ABOUT US</NavA>
                  <NavA href="/contact">CONTACT US</NavA>
                  <a
                    href="/login"
                    className="mt-2 block w-full rounded-lg bg-red-600 px-4 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-700"
                    onClick={() => setOpen(false)}
                  >
                    LOGIN
                  </a>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
